import { render, staticRenderFns } from "./product-description-variant.vue?vue&type=template&id=5cb4e888"
import script from "./product-description-variant.vue?vue&type=script&lang=js"
export * from "./product-description-variant.vue?vue&type=script&lang=js"
import style0 from "./product-description.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports